// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog-footer[data-v-088f639b] {\n  position: absolute;\n  bottom: 0;\n  right: 20px;\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n  z-index: 99;\n  background-color: white;\n}\n[data-v-088f639b] .el-upload-dragger,[data-v-088f639b] .el-upload {\n  width: 98%;\n}\n.flex[data-v-088f639b] {\n  display: flex;\n  align-items: flex-end;\n}\n.flex .upload-demo[data-v-088f639b] {\n  flex: 1;\n  margin-right: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
